import React, {useEffect} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {useHistory} from 'react-router-dom';
import {Helmet} from "react-helmet";

import ProjectView from '../components/ProjectView';

// Dental
import dental1 from '../assets/images/projects/dental/1.JPG';
import dental2 from '../assets/images/projects/dental/2.JPG';
import dental3 from '../assets/images/projects/dental/3.JPG';
import dental4 from '../assets/images/projects/dental/4.JPG';
import dental5 from '../assets/images/projects/dental/5.JPG';
import dental6 from '../assets/images/projects/dental/6.JPG';
import dental7 from '../assets/images/projects/dental/7.JPG';
import dental8 from '../assets/images/projects/dental/8.JPG';
import dental9 from '../assets/images/projects/dental/9.JPG';
import dental10 from '../assets/images/projects/dental/10.JPG';
import dental11 from '../assets/images/projects/dental/11.JPG';
import dental12 from '../assets/images/projects/dental/12.JPG';
import dental13 from '../assets/images/projects/dental/13.JPG';
import dental14 from '../assets/images/projects/dental/14.JPG';
import dental15 from '../assets/images/projects/dental/15.JPG';
import dental16 from '../assets/images/projects/dental/16.JPG';
import dental17 from '../assets/images/projects/dental/17.JPG';
import dental18 from '../assets/images/projects/dental/18.JPG';
import dental19 from '../assets/images/projects/dental/19.JPG';
import dental20 from '../assets/images/projects/dental/20.JPG';

// Medical

// Optometry
import optometry1 from '../assets/images/projects/optometry/1.jpg';
import optometry2 from '../assets/images/projects/optometry/2.jpg';
import optometry3 from '../assets/images/projects/optometry/3.jpg';
import optometry4 from '../assets/images/projects/optometry/4.jpg';
import optometry5 from '../assets/images/projects/optometry/5.jpg';
import optometry6 from '../assets/images/projects/optometry/6.jpg';
import optometry7 from '../assets/images/projects/optometry/7.jpg';

// Chiropractic
import chiropractic1 from '../assets/images/projects/chiropractic/1.jpg';
import chiropractic2 from '../assets/images/projects/chiropractic/2.jpg';
import chiropractic3 from '../assets/images/projects/chiropractic/3.jpg';
import chiropractic4 from '../assets/images/projects/chiropractic/4.jpg';
import chiropractic5 from '../assets/images/projects/chiropractic/5.jpg';

// Urgent
import urgent1 from '../assets/images/projects/urgent/1.jpg';
import urgent2 from '../assets/images/projects/urgent/2.jpg';
import urgent3 from '../assets/images/projects/urgent/3.jpg';

// Pharmacy
import pharmacy1 from '../assets/images/projects/pharmacy/1.jpg';
import pharmacy2 from '../assets/images/projects/pharmacy/2.jpg';
import pharmacy3 from '../assets/images/projects/pharmacy/3.jpg';

// Clinics

// Imagery

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        height: "400px",
        [theme.breakpoints.down("md")]: {
            height: "300px",
        },
        "&:hover": {
            "& div": {
                opacity: 1
            }
        }
    },
    detailBox: {
        height: "100%",
        padding: "20px",
        backgroundImage: `linear-gradient(to bottom, #ffffff00,${theme.palette.primary.main} )`,
        cursor: "pointer",
        transition: "0.5s",
        opacity: 0
    },
    detailTitle: {
        color: theme.palette.common.white
    },
    detailSubtitle: {
        color: theme.palette.common.white
    },
    tab: {
        border: `solid ${theme.palette.primary.main} 1px`,
        cursor: "pointer",
        transition: "0.5s",

        [theme.breakpoints.down("md")]: {
            fontSize: "14px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "10px",
        },

        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        },
    },
    tabSelected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
}))


export default function Projects(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const [collapseChecked, setCollapseChecked] = React.useState(0);
    const [tabSelected, setTabSelected] = React.useState(0);
    const [category, setCategory] = React.useState("All");
    const [currentPage, setCurrentPage] = React.useState(0);
    const [itemInPage, setItemInPage] = React.useState(4);
    const history = useHistory();
    const categoryUrl = props.match.params.category;

    const setMenuSelected = props.setMenuSelected;
    useEffect(() => {
        if (setMenuSelected) {
            window.scrollTo(0, 0);
            setMenuSelected("projects");
        }

        switch (categoryUrl) {
            case "Dental":
                setCategory("Dental offices");
                setTabSelected(1);
                history.push('/projects');
                break;

            case "Optometry":
                setCategory("Optometry offices");
                setTabSelected(2);
                history.push('/projects');
                break;

            case "Chiropractic":
                setCategory("Chiropractic offices");
                setTabSelected(3);
                history.push('/projects');
                break;

            case "Urgent":
                setCategory("Urgent care facilities");
                setTabSelected(4);
                history.push('/projects');
                break;

            case "Pharmacy":
                setCategory("Pharmacy outlets");
                setTabSelected(5);
                history.push('/projects');
                break;


            case "Medical":
                setCategory("Medical offices");
                setTabSelected(6);
                history.push('/projects');
                break;

            case "Clinics":
                setCategory("Clinics and hospitals");
                setTabSelected(7);
                history.push('/projects');
                break;

            case "Imagery":
                setCategory("Imagery and laboratory offices");
                setTabSelected(8);
                history.push('/projects');
                break;

            default:
                setTabSelected(0);
                history.push('/projects');
                break;
        }

    }, []);

    const scrollHandle = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector('#startProject');

        if (anchor) {
            anchor.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    const nextHandle = (event) => {
        if (currentPage < parseInt(projects.length / itemInPage) - 1) {
            setCurrentPage(currentPage + 1);
            scrollHandle(event);
        }
    }

    const previousHandle = (event) => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
            scrollHandle(event);
        }
    }

    const projects = [
        {
            id: 1,
            category: "Dental offices",
            // srcBeforeAfter: [[[projects71], [projects72]]],
            // altBeforeAfter: ["Dental offices remodel", "Dental offices remodeling"],
            srcImages: [dental1, dental2, dental3, dental4, dental5, dental6, dental7, dental8, dental9, dental10,
                dental11, dental12, dental13, dental14, dental15, dental16, dental17, dental18, dental19, dental20],
            altImages: ["Dental offices"],
        },
        {
            id: 2,
            category: "Optometry offices",
            srcImages: [optometry1, optometry2, optometry3, optometry4, optometry5, optometry6, optometry7],
            altImages: ["Optometry offices"],
        },
        {
            id: 3,
            category: "Chiropractic offices",
            srcImages: [chiropractic1, chiropractic2, chiropractic3, chiropractic4, chiropractic5],
            altImages: ["Chiropractic offices"],
        },
        {
            id: 4,
            category: "Urgent care facilities",
            srcImages: [urgent1, urgent2, urgent3],
            altImages: ["Urgent care facilities"],
        },
        {
            id: 5,
            category: "Pharmacy outlets",
            srcImages: [pharmacy1, pharmacy2, pharmacy3],
            altImages: ["Pharmacy outlets"],
        },
        {
            id: 6,
            category: "Medical offices",
            srcImages: [],
            altImages: ["Medical offices"],
        },
        {
            id: 7,
            category: "Clinics and hospitals",
            srcImages: [],
            altImages: ["Clinics and hospitals"],
        },
        {
            id: 8,
            category: "Imagery and laboratory offices",
            srcImages: [],
            altImages: ["Imagery and laboratory offices"],
        },
    ]

    return (
        <React.Fragment>
            <Helmet>
                <title>Projects - remodeling contractors, modern house & home decor ideas</title>
                <meta name="description" key="description" content="Our services include construction of new buildings, tenant fit outs
                and renovation of existing facilities such as Dental offices, Medical offices, Optometry offices and more."/>
                <meta property="og:title" key="og:title" content="Our services include construction of new buildings, tenant fit outs
                and renovation of existing facilities such as Dental offices, Medical offices, Optometry offices and more."/>
            </Helmet>

            <Grid container direction="column" id="projects" style={{paddingTop: "100px", paddingBottom: "100px"}}>

                <Grid item className={classes.container} id="startProject">
                    <Typography variant="h2" gutterBottom>PROJECTS</Typography>
                </Grid>
                <Grid item className={classes.container}>
                    <Typography variant="h1" paragraph>Our Projects</Typography>
                </Grid>

                <Grid item style={{marginTop: "50px"}} className={classes.container}>
                    <Grid container direction="row" spacing={1}>
                        <Grid item md={4} xs={12}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 0 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(0);
                                            setCategory("All");
                                            setCurrentPage(0)
                                        }}>
                                All</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 1 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(1);
                                            setCategory("Dental offices");
                                            setCurrentPage(0)
                                        }}>
                                Dental offices</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 2 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(2);
                                            setCategory("Optometry offices");
                                            setCurrentPage(0)
                                        }}>
                                Optometry offices</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 3 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(3);
                                            setCategory("Chiropractic offices");
                                            setCurrentPage(0)
                                        }}>
                                Chiropractic offices</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 4 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(4);
                                            setCategory("Urgent care facilities");
                                            setCurrentPage(0)
                                        }}>
                                Urgent care facilities</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 5 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(5);
                                            setCategory("Pharmacy outlets");
                                            setCurrentPage(0)
                                        }}>
                                Pharmacy offices</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 6 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(6);
                                            setCategory("Medical offices");
                                            setCurrentPage(0)
                                        }}>
                                Medical outlets</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 7 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(7);
                                            setCategory("Clinics and hospitals");
                                            setCurrentPage(0)
                                        }}>
                                Clinics and hospitals</Typography>
                        </Grid>

                        <Grid item md={4} xs={6}>
                            <Typography component="h1" variant="subtitle2" align="center" gutterBottom
                                        className={`${classes.tab} ` + `${tabSelected === 8 ? classes.tabSelected : null}`}
                                        onClick={() => {
                                            setTabSelected(8);
                                            setCategory("Imagery and laboratory offices");
                                            setCurrentPage(0)
                                        }}>
                                Imagery and laboratory offices</Typography>
                        </Grid>

                    </Grid>
                </Grid>

                {
                    projects.filter(project => (project.category === category || category === "All"))
                        .slice(currentPage * itemInPage, (currentPage * itemInPage) + itemInPage)
                        .map((project, index) => (
                            <Grid key={project.id} item container direction="column" style={{
                                paddingTop: "50px",
                                paddingBottom: "50px",
                                backgroundColor: index % 2 === 1 ? theme.palette.background.bg2 : null
                            }} className={classes.container}>
                                <Grid item>
                                    <Typography component="h1" variant="h1" paragraph>
                                        {project.category}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    {/*<ProjectView beforeAfters={project.srcBeforeAfter} altBeforeAfters={project.altBeforeAfter} images={project.srcImages} altImages={project.altImages} />*/}
                                    <ProjectView images={project.srcImages} altImages={project.altImages}/>
                                </Grid>
                            </Grid>
                        ))
                }

                {

                    projects.filter(project => (project.category === category || category === "All")).length <= 0 ?
                        <Grid item container direction="column" style={{paddingTop: "50px", paddingBottom: "50px"}}
                              className={classes.container}>
                            <Typography variant="h1" paragraph>
                                There is no project to show.
                            </Typography>
                        </Grid>
                        : null
                }

                {
                    projects.filter(project => (project.category === category || category === "All")).length > itemInPage ?
                        <Grid item style={{marginTop: "50px"}} className={classes.container}>
                            <Grid container direction="row" spacing={1}>

                                <Grid item xs>
                                    <Typography variant="subtitle2" align="center" gutterBottom
                                                className={`${classes.tab} `}
                                                onClick={(e) => previousHandle(e)}>
                                        {"< "}Previous
                                    </Typography>
                                </Grid>

                                {[...Array(parseInt(projects.length / itemInPage))].map((e, index) => (


                                    <Grid key={index} item xs>
                                        <Typography variant="subtitle2" align="center" gutterBottom
                                                    className={`${classes.tab} ` + `${currentPage === index ? classes.tabSelected : null}`}
                                                    onClick={(e) => {
                                                        setCurrentPage(index);
                                                        scrollHandle(e)
                                                    }}>
                                            {index + 1}
                                        </Typography>
                                    </Grid>


                                ))}

                                <Grid item xs>
                                    <Typography variant="subtitle2" align="center" gutterBottom
                                                className={`${classes.tab} `}
                                                onClick={(e) => nextHandle(e)} role="presentation">
                                        Next {" >"}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>
                        : <div></div>
                }


            </Grid>
        </React.Fragment>

    );
}
